import $httpNoErrorCatch from '@/api/without-catches';

export default {
  async titleSuggestion(profileName, title, subtitle, body, mainCategory) {
    return $httpNoErrorCatch.post('/api/bcube-assistant/suggestion/title', {
      profileName, title, subtitle, body, mainCategory,
    });
  },
  async subtitleSuggestion(profileName, title, subtitle, body, mainCategory) {
    return $httpNoErrorCatch.post('/api/bcube-assistant/suggestion/subtitle', {
      profileName, title, subtitle, body, mainCategory,
    });
  },
  async socialNetworkSummary(profileName, title, subtitle, body, mainCategory) {
    return $httpNoErrorCatch.post('/api/bcube-assistant/social-network/summary', {
      profileName, title, subtitle, body, mainCategory,
    });
  },
};
